import React from "react";
import * as LucideIcons from "lucide-react";

export const Icons = {
  Zap: (props) => <LucideIcons.Zap {...props} />,
  Shield: (props) => <LucideIcons.Shield {...props} />,
  Globe: (props) => <LucideIcons.Globe {...props} />,
  Truck: (props) => <LucideIcons.Truck {...props} />,
  Package: (props) => <LucideIcons.Package {...props} />,
  Users: (props) => <LucideIcons.Users {...props} />,
  Search: (props) => <LucideIcons.Search {...props} />,
  ChevronRight: (props) => <LucideIcons.ChevronRight {...props} />,
  ChevronDown: (props) => <LucideIcons.ChevronDown {...props} />,
  Check: (props) => <LucideIcons.Check {...props} />,
  CheckCircle: (props) => <LucideIcons.CheckCircle {...props} />,
  Mail: (props) => <LucideIcons.Mail {...props} />,
  Phone: (props) => <LucideIcons.Phone {...props} />,
  MapPin: (props) => <LucideIcons.MapPin {...props} />,
  ArrowRight: (props) => <LucideIcons.ArrowRight {...props} />,
  Star: (props) => <LucideIcons.Star {...props} />,
  Menu: (props) => <LucideIcons.Menu {...props} />,
  Linkedin: (props) => <LucideIcons.Linkedin {...props} />,
  Twitter: (props) => <LucideIcons.Twitter {...props} />,
  Facebook: (props) => <LucideIcons.Facebook {...props} />,
  Clock: (props) => <LucideIcons.Clock {...props} />,
  Award: (props) => <LucideIcons.Award {...props} />,
  BarChart: (props) => <LucideIcons.BarChart {...props} />,
  Headphones: (props) => <LucideIcons.Headphones {...props} />,
  Tag: (props) => <LucideIcons.Tag {...props} />,
};
